import { mockProviders } from '../app/core/mock/mock.providers';

export const environment = {
  defaultLanguage: 'pl',
  languages: ['pl', 'en'],
  apiUrl: 'https://mock.local/api',
  useMocks: true,
  mockProviders,
  keycloak: {
    url: 'https://mock.local/keycloak',
    realm: 'ksiegowskaz-hr',
    clientId: 'ksiegowskaz-hr-frontend',
  },
};
